// Modules
import React from 'react';

// Utils
import { formatPhone } from './utils/phoneValidation';

// Styles
import styles from './PracticeBanner.module.scss';

const PracticeBanner = (props) => {
  const { imgUrl, date, name, street, city, state, zip, phone } = props;

  const handleError = (e) => {
    console.log(
      `Could not get image from ${e?.target?.src}, removing image from PracticeBanner component`
    );
    const parent = e.target.parentElement;
    parent.removeChild(e.target);
  };

  return (
    <div className={styles.container}>
      <img
        className={styles.img}
        src={imgUrl}
        alt={name}
        onError={handleError}
      />

      <p className={styles.date}>{date}</p>

      <div className={styles.details}>
        <h3>{name}</h3>
        <p>{street}</p>
        <p>
          {city}
          {city ? ', ' : ''}
          {state}
          {state ? ' ' : ''}
          {zip}
        </p>
        {phone ? <p>{formatPhone(phone)}</p> : null}
      </div>
    </div>
  );
};

export default PracticeBanner;
